<template>
    <div class="bg-white app-content contact">
        <div class="center">
            <div class="left">
                <div class="fs20 fw700 mb20 black">联系我们</div>
                <div class="row mb10">
                    <div class="fw700 label">
                        联系地址
                    </div>
                    <div class="detail">
                        iresgke oorhert: curmgesuies thrvugh thke world,patrsry iieagel Siau a reey dhelenge wit petwety inage.G eali.wrle s, desigrers as wel as wreue bushess parrer shipoffetngs are welcome.
                    </div>
                </div>
                <div class="row mb10">
                    <div class="fw700 label">
                        邮件地址
                    </div>
                    <div class="detail">
                        [123456, By ceck in lurg yu Sead 12345 passage buirg
                    </div>
                </div>
                <div class="row mb10">
                    <div class="fw700 label">
                        联系电话
                    </div>
                    <div class="detail">
                        02-1234-5678
                    </div>
                </div>
                <div class="row mb10">
                    <div class="fw700 label">
                        传真
                    </div>
                    <div class="detail">
                        02-1234-5678
                    </div>
                </div>
            </div>
            <div class="right">
                <el-button
                    type="primary" 
                    round
                    class="right-btn"
                >
                    起件发送
                </el-button>
            </div>
        </div>
    </div>
  </template>
  <script>
  export default {
    name: 'ContactInfoIndex',
    data() {
        return {

        }
    }
    
  };
  </script>
  <style scoped>
  .contact{
    height: 300px;
    background:linear-gradient(to bottom,rgb(237 246 250), rgb(220 227 242));
    /* background-image: linear-gradient(to bottom, #cfdfe8, #f0f6f6); */
  }
  .center{
    margin: 0 auto;
    width: 70%;
    height: 100%;
    display: flex;
  }
  .left {
    width: 60%;
    margin: 30px 50px;
    padding: 20px;
    }
    .row {
        display: flex;
        width: 100%;
    }
    .row .label {
        color: black;
        width: 17%;
    }
    .row .detail {
        width: 75%;
    }
  
  .right {
    width: 40%;
    /* padding: ; */
    margin: 50px 10px ;
    background-color: white;
    text-align: center;
    position: relative;
  }
  .right-btn{
    position: absolute;
    width: 100px;
    padding: 5px 10px;
    bottom: 10px;
    left: 35%;
  }
  </style>